import React from "react";

import "react-quill/dist/quill.snow.css";

import dynamic from "next/dynamic";

import parse from "html-react-parser";

const ReactQuill = dynamic(() => import("react-quill"), { ssr: false });

type RichTextEditorProps = React.ComponentProps<typeof ReactQuill>;

const RichTextEditor = ({ ...props }: RichTextEditorProps) => {
  return (
    <ReactQuill
      {...props}
      theme="snow"
      formats={[
        "header",
        "bold",
        "italic",
        "underline",
        "strike",
        "blockquote",
        "list",
        "bullet",
        "indent",
        "code-block",
      ]}
      modules={{
        toolbar: [
          [{ header: [1, 2, 3, 4, false] }],
          ["bold", "italic", "underline"],
          [
            { list: "ordered" },
            { list: "bullet" },
            { indent: "-1" },
            { indent: "+1" },
          ],
          ["code-block"],
        ],
      }}
    />
  );
};

export default RichTextEditor;

export const RichTextViewer = ({ richText }: { richText: string }) => {
  return <div className="rich-text-editor-display">{parse(richText)}</div>;
};
